// BHP-1070: the active customer is client-state, persisted so the choice
// survives reloads and navigation, replacing the legacy localStorage handling.
// Every request carries it as the `x-active-customer` header (shared/http), and
// Backend2.0 narrows reads to it, for an admin too (BHP-1081, BHP-1259).
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveCustomerState {
  activeCustomerUuid: string | null;
  setActiveCustomer: (uuid: string | null) => void;
  clear: () => void;
}

export const ACTIVE_CUSTOMER_STORAGE_KEY = 'bhp.activeCustomer';

export const useActiveCustomerStore = create<ActiveCustomerState>()(
  persist(
    (set) => ({
      activeCustomerUuid: null,
      setActiveCustomer: (uuid) => {
        set({ activeCustomerUuid: uuid });
      },
      clear: () => {
        set({ activeCustomerUuid: null });
      }
    }),
    { name: ACTIVE_CUSTOMER_STORAGE_KEY }
  )
);
